var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"app-wrapper",class:_vm.classObj},[_c('div',{staticClass:"main-container"},[_c('app-main')],1),_c('bottom-tab-bar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }